"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fluxible_1 = require("fluxible");
const fetchrPlugin = require("fluxible-plugin-fetchr");
const Application_1 = require("./frontend/components/Application");
const ApplicationStore_1 = require("./frontend/stores/ApplicationStore");
const BlogStore_1 = require("./frontend/stores/BlogStore");
const RouteStore_1 = require("./frontend/stores/RouteStore");
const ExtraStore_1 = require("./frontend/stores/ExtraStore");
// create new fluxible instance
const app = new fluxible_1.Fluxible({
    component: Application_1.default,
});
const fetchrPluginInst = fetchrPlugin({
    xhrPath: '/api',
});
app.plug(fetchrPluginInst);
// register stores
app.registerStore(RouteStore_1.default);
app.registerStore(ApplicationStore_1.default);
app.registerStore(BlogStore_1.default);
app.registerStore(ExtraStore_1.default);
exports.default = app;
